import React, { useState } from "react";
import axios from "axios";
import Navbar from "../Navbar";
import Footer from "../Footer";
import Popup from "../Popup";
import {
    WORDPRESS_URL,
    WP_CATEGORIES_SLUG,
    WP_POST_CATEGORIES_WITH_FEATUREDMEDIA
} from "../../utils/constants";
import { Link } from "react-router-dom";
import renderHTML from "react-render-html";
import kosodelnik from "../../images/kosodelnik.png";
import kosodelnikModry from "../../images/kosodelnik-modry.png";
import home1 from "../../images/home1.jpg";
import home2 from "../../images/home2.jpg";
import home3 from "../../images/home3.jpg";
import Preloader from "../Preloader";
import defaultBg from "../../images/category-clanek.jpg";

class Homepage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        bodyPost: { idx: "", title: "", text: "", shortText: "", slug: "", date: "" },
        footerPost: { idx: "", title: "", text: "", shortText: "", slug: "", date: "" },
        footerCategory: { id: 0 },
        footerPosts: [],
        aktualityCategory: { id: 0 },
        actualityPosts: [],
        actualityPost: { idx: "", title: "", text: "", shortText: "", slug: "", date: "" },
        index: 1,
        indexRef: 1,
        headerBgClass: "home",
        firstRectSrc: kosodelnikModry,
        secondRectSrc: kosodelnik, 
        thirdRectSrc: kosodelnik, 
        nextHeaderBgIndex: 2,
        firstArticle: "",
        secondArticle: "hidden",
        thirdArticle: "hidden",
        whoWeAreImg: home1,
        whoWeAre: [home1, home2, home3],
        whoWeAreIndex: 1,
        error: "",
        isLoading: true,
        actualitiesArray: [],
        showPopup: true
    };
  }

 togglePopup = () => {
    this.setState({
      showPopup: !this.state.showPopup,
    });
  }

  componentDidMount() {
    console.log("showPopup", this.state.showPopup);
     if(!localStorage.POPUP || localStorage.POPUP < new Date()){
        var date = new Date();
        date.setDate(date.getDate() + 1);
        localStorage.setItem("POPUP", date);
    }
    else{
        this.setState({showPopup:false});
    }
    
    const WHO_WE_ARE = "produkty-a-sluzby";

    axios.get( WORDPRESS_URL + WP_CATEGORIES_SLUG  + WHO_WE_ARE)
    .then(response_slug => {
        if (response_slug !== undefined) {
            axios.get( WORDPRESS_URL + WP_POST_CATEGORIES_WITH_FEATUREDMEDIA + response_slug.data[0].id + '&per_page=100')
            .then(response_actualities => {
                if (response_actualities !== undefined) {
                    const actualitiesArray = response_actualities.data.map(function (data, id){
                        let featuredMediaLinks = data._embedded['wp:featuredmedia'] ? data._embedded['wp:featuredmedia'] : null;
                        let featuredMediaLink = featuredMediaLinks ? `url("${featuredMediaLinks[0].source_url}")` : `url("${defaultBg}")`; //rest api na získání úvodního obrázku
                        return {
                            idx: id,
                            title: data.title.rendered,
                            text: data.content.rendered, 
                            shortText: data.excerpt.rendered,
                            slug: data.slug,
                            featuredMedia: featuredMediaLink
                        };
                    });
    
                    this.setState({
                        isLoading: false, 
                        actualitiesArray: actualitiesArray
                    }); 
                }                     
            });
        }                                   
    })
    .catch( error => {
        console.log(error);  

        this.setState({ 
            error: error, 
            isLoading: false,
            redirectInternalError: true
        });       
    });

  }

renderHeader = () => {
    return(
        <header className={this.state.headerBgClass}>
            <div className="header-overlay">
            <Navbar />
            
            <div className="sd-container">
                <section id="sub-header">
                <div className="row">
                    <div className="col-md-7 col-xl-8 ">
                    <div className="d-flex justify-content-between align-items-center">
                        <h6 className="sub-header-caption text-uppercase title-border-radius link">
                        Umíme velké věci
                        </h6>
                    </div>
                     <ul id="navrow-1" className="nav ml-auto">

                    <li className="nav-item d-inline-block" role="presentation">
                        <a href="https://www.prodeco.cz/admin/wp-content/uploads/2025/12/prodeco_letak_a4_vyrobni_moznosti.pdf" target="_blank" className="nav-link active pl-0">Výrobní možnosti</a>
                    </li>

                    <li className="nav-item d-inline-block" role="presentation">
                        <a href="https://www.prodeco.cz/admin/wp-content/uploads/2026/01/prodeco_letak_a4_afirex.pdf" target="_blank" className="nav-link active ">SHZ</a>
                    </li>

                    <li className="nav-item d-inline-block" role="presentation">
                        <a href="https://www.prodeco.cz/admin/wp-content/uploads/2025/12/prodeco_letak_a4_fve.pdf" target="_blank" className="nav-link active ">FVE</a>
                    </li>

                    <li className="nav-item d-inline-block" role="presentation">
                        <a href="https://www.prodeco.cz/admin/wp-content/uploads/2025/12/prodeco_letak_a4_dulni_technologie.pdf" target="_blank" className="nav-link active ">Důlní technologie</a>
                    </li>
                    </ul>
                    </div>

                    </div>
                </section>
            </div>
            </div>
        </header>
    );
}

renderMainContainer = () => {
    return(
        <section id="main-container">
            <div className="sd-container-aktuality category">
                <div className="d-flex sd-container-aktuality-flex sd-container-category-home">
                    <div>
                    {this.renderArticles()} 
                    </div>                       
                </div>
            </div>
        </section>
    );
}

renderArticles = () => {
    const { actualitiesArray } = this.state;

    const actualities = actualitiesArray.map((actuality, index) =>{
        if(actuality.slug === "hydraulika" || actuality.slug === "asr-elektro" || actuality.slug === "zakazkove-obrabeni" || actuality.slug === "vyroba-obecnych-ocelovych-svarencu" || actuality.slug === "shz-afirex" || actuality.slug === "dulni-technologie" || actuality.slug === "volne-kapacity"){
            return (<Link to={`clanek/${actuality.slug}`}>
            <div className="sd-category-article" key={index}>
                <div className="sd-category-article-image" style={{backgroundImage: actuality.featuredMedia }}>
            </div>
                <div className="sd-category-article-body">
                    <div className="sd-article-title">{ renderHTML(actuality.title) }</div>
                    <div className="sd-article-content">{ renderHTML(actuality.shortText) }</div>
                    
                    <div className="sd-article-link"> 
                        <span className="pull-right sd-text-primary">
                            <b>Zjistit více</b>
                            <i className="fa fa-chevron-right ml-2"></i>
                        </span>
                    </div>
                </div>
            </div>
        </Link>)
        }
        else{
            return (<Link to={`${actuality.slug}`}>
                <div className="sd-category-article" key={index}>
                    <div className="sd-category-article-image" style={{backgroundImage: actuality.featuredMedia }}>
                </div>
                    <div className="sd-category-article-body">
                        <div className="sd-article-title">{ renderHTML(actuality.title) }</div>
                        <div className="sd-article-content">{ renderHTML(actuality.shortText) }</div>
                        
                        <div className="sd-article-link"> 
                            <span className="pull-right sd-text-primary">
                                <b>Zjistit více</b>
                                <i className="fa fa-chevron-right ml-2"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </Link>)
            }
});

    return actualities;
}

renderSecondaryContainer = () => {
    return(
        <section id="secondary-container"></section>
    );
}

renderActualMobileDevice = () => {

    return(
        <section id="actual-xs">
            <div className="row m-0">
                <div className="col actual actuality-for-mobile p-50">
                <div className="d-flex justify-content-between align-items-center">
                    <h6 className="actual-into-deep-caption text-uppercase">
                    <div className="title-border-radius">O společnosti</div>
                    </h6>
                </div>

                <div className="d-flex justify-content-between align-items-center mobile-button-div">
                    <Link
                    to={`o-spolecnosti`}
                    className="who-we-are-more-btn-link"
                    >
                    <div className="actual-more-btn link text-white">
                        <span className="btn-text">
                        Více o společnosti <i className="fa fa-chevron-right ml-2"></i>
                        </span>
                    </div>
                    </Link>
                </div>
                </div>
            </div>
        </section>
    );
}

renderFooter = () => {

    return(
        <footer>
            <div className="sd-container">
                <section id="actual-into-deep">
                    <div className="row m-0">
                        <div className="col-md-6 p-50 actual sd-hidden-xs">
                        <div className="d-flex justify-content-between align-items-center">
                            <h6 className="actual-into-deep-caption text-uppercase">
                            <div className="title-border-radius">O Společnosti</div>
                            </h6>
                        </div>
                        <Link
                            to={`o-spolecnosti`}
                            className="who-we-are-more-btn-link"
                        >
                            <div className="actual-more-btn link text-white">
                            <span className="btn-text">
                            Více o společnosti{" "}
                                <i className="fa fa-chevron-right ml-2"></i>
                            </span>
                            </div>
                        </Link>
                        </div>
                        <div className="col-md-6 p-50 into-deep">
                        <div className="d-flex justify-content-between align-items-center">
                            <h6 className="actual-into-deep-caption text-uppercase">
                            <div className="title-border-radius">Reference</div>
                            </h6>
                        </div>
                        <Link
                             to={`reference`}
                            className="who-we-are-more-btn-link mobile-button-div"
                        >
                            <div className="actual-more-btn link text-white">
                            <span className="btn-text">
                                Více referencí{" "}
                                <i className="fa fa-chevron-right ml-2"></i>
                            </span>
                            </div>
                        </Link>
                        </div>
                    </div>
                </section>

                <section id="footer-content" className="footer-top-padding">
                    <Footer />
                </section>
            </div>
        </footer>            
    );
}

render() {
    const { isLoading } = this.state; 
    //const isLoading  = true; 

    return (  
        <section id="web">
            <div id="preload">
                {/* <img src={require('../../images/header-bg.jpg')}></img> */}
            </div>

            {isLoading ? (
                <Preloader isLoaded={!isLoading} />
            ) : ( 
                <div className="wrapper">
                    {this.renderHeader()}

                    {this.renderMainContainer()}

                    {this.renderSecondaryContainer()}

                    {this.renderActualMobileDevice()}

                    {this.renderFooter()}

                    {this.state.showPopup ?
                        <Popup closePopup={() => this.togglePopup()} />
                        : null
                    }
                </div>
            )}
        </section>
    );
  }
}

export default Homepage;